/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiIntegrationsObjectsIntegrationState = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;
export type WebApiIntegrationsObjectsIntegrationState = typeof WebApiIntegrationsObjectsIntegrationState[keyof typeof WebApiIntegrationsObjectsIntegrationState];


export function WebApiIntegrationsObjectsIntegrationStateFromJSON(json: any): WebApiIntegrationsObjectsIntegrationState {
    return WebApiIntegrationsObjectsIntegrationStateFromJSONTyped(json, false);
}

export function WebApiIntegrationsObjectsIntegrationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsObjectsIntegrationState {
    return json as WebApiIntegrationsObjectsIntegrationState;
}

export function WebApiIntegrationsObjectsIntegrationStateToJSON(value?: WebApiIntegrationsObjectsIntegrationState | null): any {
    return value as any;
}

